import { Button, Card, Text, Title } from "@mantine/core";
import ArrowForwardRounded from "@mui/icons-material/ArrowForwardRounded";
import Link from "next/link";
import classes from "./cta-card.module.css";

interface CTACardProps {
  title: string;
  description: string;
  buttonText: string;
  href: string;
  variant?: "primary" | "secondary";
  icon?: React.ReactNode;
}

export default function CTACard({
  title,
  description,
  buttonText,
  href,
  variant = "secondary",
  icon,
}: CTACardProps) {
  return (
    <Card className={classes.card} data-variant={variant}>
      <div className={classes.header}>
        {icon && <div className={classes.icon}>{icon}</div>}
        <Title order={3} className={classes.title}>
          {title}
        </Title>
        <Text className={classes.description}>{description}</Text>
      </div>
      <Button
        aria-label={buttonText}
        title={buttonText}
        component={Link}
        href={href}
        className={classes.button}
        fullWidth
        rightSection={<ArrowForwardRounded className={classes.buttonIcon} />}
        size="md"
        radius="md"
      >
        {buttonText}
      </Button>
    </Card>
  );
}
